import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.css'],
  animations: [
    trigger('preLoader', [
      // state('in', style({ transform: 'translateX(0)' })),
      // transition('void => *', [
      //   style({ transform: 'translateX(100%)' }),
      //   animate(500)
      // ]),
      // transition('* => void', [
      //   animate(500, style({ transform: 'translateX(100%)' }))
      // ])
    ])
  ]
})
export class PreloaderComponent implements OnInit, OnChanges {

  @Input() showLoader: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for(const _propName in changes) {
      if(changes.hasOwnProperty(_propName)){
        switch (_propName){
          case "showLoader":
            if(changes.showLoader.currentValue) {
              document.body.classList.add('preloader');
            } else {
              document.body.classList.remove('preloader');
            }
            break;
        }
      }
    }
  }

}
